export const limitedReleaseByVersionConstants = {
  LIMITED_RELEASE_BY_VERSION_LOADING: "LIMITED_RELEASE_BY_VERSION_LOADING",
  LIMITED_RELEASE_BY_VERSION_SUCCESS: "LIMITED_RELEASE_BY_VERSION_SUCCESS",
  LIMITED_RELEASE_BY_VERSION_FAILURE: "LIMITED_RELEASE_BY_VERSION_FAILURE",
};

export const createLimitedReleaseByVersionConstants = {
  CREATE_LIMITED_RELEASE_BY_VERSION_LOADING:
    "CREATE_LIMITED_RELEASE_BY_VERSION_LOADING",
  CREATE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
    "CREATE_LIMITED_RELEASE_BY_VERSION_SUCCESS",
  CREATE_LIMITED_RELEASE_BY_VERSION_FAILURE:
    "CREATE_LIMITED_RELEASE_BY_VERSION_FAILURE",
};

export const editLimitedReleaseByVersionConstants = {
  EDIT_LIMITED_RELEASE_BY_VERSION_LOADING:
    "EDIT_LIMITED_RELEASE_BY_VERSION_LOADING",
  EDIT_LIMITED_RELEASE_BY_VERSION_SUCCESS:
    "EDIT_LIMITED_RELEASE_BY_VERSION_SUCCESS",
  EDIT_LIMITED_RELEASE_BY_VERSION_FAILURE:
    "EDIT_LIMITED_RELEASE_BY_VERSION_FAILURE",
};

export const deleteLimitedReleaseByVersionConstants = {
  DELETE_LIMITED_RELEASE_BY_VERSION_LOADING:
    "DELETE_LIMITED_RELEASE_BY_VERSION_LOADING",
  DELETE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
    "DELETE_LIMITED_RELEASE_BY_VERSION_SUCCESS",
  DELETE_LIMITED_RELEASE_BY_VERSION_FAILURE:
    "DELETE_LIMITED_RELEASE_BY_VERSION_FAILURE",
};

export const addTargetLimitedReleaseByVersionConstants = {
  ADD_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING:
    "ADD_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING",
  ADD_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS:
    "ADD_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS",
  ADD_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE:
    "ADD_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE",
};

export const removeTargetLimitedReleaseByVersionConstants = {
  REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_LOADING",
  REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_SUCCESS",
  REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_VERSION_FAILURE",
};

export const activateLimitedReleaseByVersionConstants = {
  ACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING:
    "ACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING",
  ACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
    "ACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS",
  ACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE:
    "ACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE",
};

export const deactivateLimitedReleaseByVersionConstants = {
  DEACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING:
    "DEACTIVATE_LIMITED_RELEASE_BY_VERSION_LOADING",
  DEACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS:
    "DEACTIVATE_LIMITED_RELEASE_BY_VERSION_SUCCESS",
  DEACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE:
    "DEACTIVATE_LIMITED_RELEASE_BY_VERSION_FAILURE",
};
